import React from 'react';
import { LayoutGridIcon, TrendingUpIcon, PaletteIcon, UserPlusIcon, MessageSquareIcon, WorkflowIcon, SettingsIcon, UsersIcon, ShieldCheckIcon, FileBoxIcon, LayoutTemplateIcon } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';
import { ViewModeSwitcher } from './ViewModeSwitcher';
import { useViewMode } from '../context/ViewModeContext';
export const Sidebar = () => {
  const location = useLocation();
  const {
    viewMode
  } = useViewMode();
  // Define menu items based on view mode
  const brandMenuItems = [{
    path: '/brand/dashboard',
    label: 'Executive Hub',
    icon: TrendingUpIcon
  }, {
    path: '/brand/partners',
    label: 'Partner Management',
    icon: UsersIcon
  }, {
    path: '/brand/compliance',
    label: 'Compliance',
    icon: ShieldCheckIcon
  }, {
    path: '/brand/templates',
    label: 'Campaign Templates',
    icon: LayoutTemplateIcon
  }, {
    path: '/brand/assets',
    label: 'Brand Assets',
    icon: FileBoxIcon
  }, {
    path: '/growth-console',
    label: 'Growth Console',
    icon: TrendingUpIcon
  }, {
    path: '/campaigns',
    label: 'All Campaigns',
    icon: LayoutGridIcon
  }, {
    path: '/creative-customizer',
    label: 'Creative Customizer',
    icon: PaletteIcon
  }, {
    path: '/leads',
    label: 'Leads',
    icon: UserPlusIcon
  }, {
    path: '/conversations',
    label: 'Conversations',
    icon: MessageSquareIcon
  },
  // No Workflows for Brand view
  {
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon
  }];
  const storeMenuItems = [{
    path: '/growth-console',
    label: 'Growth Console',
    icon: TrendingUpIcon
  }, {
    path: '/campaigns',
    label: 'Campaigns',
    icon: LayoutGridIcon
  }, {
    path: '/creative-customizer',
    label: 'Creative Customizer',
    icon: PaletteIcon
  }, {
    path: '/leads',
    label: 'Leads',
    icon: UserPlusIcon
  }, {
    path: '/conversations',
    label: 'Conversations',
    icon: MessageSquareIcon
  }, {
    path: '/workflows',
    label: 'Workflows',
    icon: WorkflowIcon
  }, {
    path: '/settings',
    label: 'Settings',
    icon: SettingsIcon
  }];
  const menuItems = viewMode === 'brand' ? brandMenuItems : storeMenuItems;
  return <div className="w-60 bg-[#0a0a3a] text-white min-h-screen flex flex-col" data-id="element-1475">
      {/* Logo */}
      <div className="p-4 border-b border-[#1a1a4a]" data-id="element-1476">
        <div className="flex items-center space-x-3" data-id="element-1477">
          <div className="bg-white rounded p-2 w-10 h-10 flex items-center justify-center" data-id="element-1478">
            <div className="grid grid-cols-3 gap-0.5" data-id="element-1479">
              {[...Array(9)].map((_, i) => <div key={i} className="w-1.5 h-1.5 rounded-sm bg-blue-600" data-id="element-1480"></div>)}
            </div>
          </div>
          <span className="font-bold text-lg" data-id="element-1481">Platform</span>
        </div>
      </div>

      {/* View Mode Switcher */}
      <div className="p-4 border-b border-[#1a1a4a]" data-id="element-1482">
        <ViewModeSwitcher data-id="element-1483" />
      </div>

      {/* Navigation */}
      <nav className="mt-2 flex-1 overflow-y-auto" data-id="element-1484">
        {menuItems.map(item => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
        return <Link key={item.path} to={item.path} className={`flex items-center px-6 py-3 transition-colors ${isActive ? 'bg-blue-600' : 'hover:bg-[#1a1a4a]'}`} data-id="element-1485">
              <Icon size={18} className="mr-3" data-id="element-1486" />
              <span className="text-sm" data-id="element-1487">{item.label}</span>
            </Link>;
      })}
      </nav>

      {/* View Mode Indicator */}
      <div className="p-4 border-t border-[#1a1a4a]" data-id="element-1488">
        <div className={`px-3 py-2 rounded-lg text-xs font-medium text-center ${viewMode === 'brand' ? 'bg-purple-500/20 text-purple-300' : 'bg-emerald-500/20 text-emerald-300'}`} data-id="element-1489">
          {viewMode === 'brand' ? '🏢 Brand Mode' : '🏪 Store Mode'}
        </div>
      </div>
    </div>;
};